// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PatientCommsContactMethods from './data'

export default function PatientCommsContactMethodsFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PatientComms/PatientCommsContactMethods">
      <PatientCommsContactMethods {...props}>
        {children}
      </PatientCommsContactMethods>
    </Flow>
  )
}
